import clsx from 'clsx';
import { type ComponentPropsWithoutRef, type ForwardedRef, forwardRef } from 'react';

import {
    Card,
    CardButton,
    type CardButtonProps,
    type CardProps,
    HeadingContext,
    Image,
    type ImageProps,
} from '@gitbook/spine-react';

export const TemplateCard = forwardRef(function TemplateCard(
    props: CardProps,
    ref: ForwardedRef<HTMLDivElement>
) {
    return (
        <Card
            ref={ref}
            {...props}
            className={clsx('group flex flex-col overflow-hidden rounded-md', props.className)}
        >
            <HeadingContext.Provider value={{ level: 3 }}>{props.children}</HeadingContext.Provider>
        </Card>
    );
});

export const TemplateCardButton = forwardRef(function TemplateCardButton(
    props: CardButtonProps,
    ref: ForwardedRef<HTMLDivElement>
) {
    return (
        <CardButton
            ref={ref}
            {...props}
            className={clsx('group flex flex-col overflow-hidden rounded-md', props.className)}
        >
            <HeadingContext.Provider value={{ level: 3 }}>{props.children}</HeadingContext.Provider>
        </CardButton>
    );
});

export function TemplateCardActions(props: ComponentPropsWithoutRef<'div'>) {
    const { children, ...rest } = props;
    return (
        <div
            {...rest}
            className={clsx(
                'absolute inset-0 z-10 flex flex-1 items-center justify-center gap-3 opacity-0 transition group-hover:opacity-100 has-[:focus-visible]:opacity-100',
                props.className
            )}
        >
            {children}
            <div className="-z-10 absolute inset-0 bg-overlay/40 opacity-0 transition duration-300 ease-in-out group-hover:opacity-100" />
        </div>
    );
}

export function TemplateCardPreview(props: ComponentPropsWithoutRef<'div'>) {
    return (
        <div
            {...props}
            className={clsx(
                'relative flex overflow-hidden border-b bg-muted p-3 pb-0',
                props.className
            )}
        />
    );
}

export function TemplateCardFooter(props: ComponentPropsWithoutRef<'div'>) {
    return <div {...props} className={clsx('relative p-4 px-5', props.className)} />;
}

export function TemplateCardImage(props: ImageProps) {
    return (
        <Image
            rounded={false}
            {...props}
            className={clsx(
                'relative aspect-video flex-1 rounded-t-md border-x border-t object-cover object-top',
                props.className
            )}
        />
    );
}
